const xapiEntryType = {
  STATE: 'state',
  STARTUP: 'startup',
  SHUTDOWN: 'shutdown',
};

export default Object.freeze(xapiEntryType);
